import { DNI } from '@/interfaces/dni';
import { queryDNI } from '@/services/dni.service';
import { Effect, Reducer } from '@umijs/max';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface ModelType {
  namespace: string;
  state: { dni: null | DNI };
  effects: {
    sendHistory: Effect;
    fetchDNIDetail: Effect;
  };
  reducers: {
    setDNI: Reducer<any>;
    setHistory: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'dniDetail',

  state: {
    dni: null,
  },

  effects: {
    *fetchDNIDetail({ payload }, { call, put, all }) {
      try {
        const [response] = yield all([call(queryDNI, payload)]);
  
        yield put({
          type: 'setDNI',
          payload: { 
            dni: response.data 
          },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *sendHistory({ payload }) {
      yield {
        type: 'setHistory',
        payload,
      };
    },
  },

  reducers: {
    setDNI(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setHistory(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
